export const TAX_LABEL_APPLIED = 'Applied';
export const TAX_LABEL_UNAPPLIED = 'Not Applied';
